// Build the public mover-app URL for a crew member, including any base path
// that the app is mounted under (e.g. Readdy previews host under /<projectId>/).
export function buildMoverUrl(accessToken: string | undefined): string {
  if (!accessToken) return "";
  const base = (__BASE_PATH__ || "/").replace(/\/+$/, ""); // strip trailing slash
  return `${window.location.origin}${base}/m/${accessToken}`;
}